import { objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, objectSpread2 as _objectSpread2, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { forwardRef } from 'react';
import { Button as Button$1 } from 'react-bootstrap';
import kebabCase from 'lodash/kebabCase.js';
import { AccessControlWrapper } from '../AccessControlWrapper.js';
import { FAIcon } from '../fa-icon/component.js';
import { InfoTooltip } from '../InfoTooltip/component.js';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';
import { pickDataAttributes } from '../../utils/pickDataAttributes.js';
var _excluded = ["block", "branded", "children", "className", "cssStyle", "data", "disabled", "download", "fontTheme", "href", "icon", "iconFamily", "iconProps", "label", "onClick", "permissions", "requiredPermission", "rightIcon", "rightIconProps", "style", "tooltipAttributes", "variant"];
/** renders a button */
var Button = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var block = props.block,
    branded = props.branded,
    children = props.children,
    className = props.className,
    cssStyle = props.cssStyle,
    _props$data = props.data,
    data = _props$data === void 0 ? {} : _props$data,
    disabled = props.disabled,
    download = props.download,
    fontTheme = props.fontTheme,
    href = props.href,
    icon = props.icon;
  props.iconFamily;
  var iconProps = props.iconProps,
    label = props.label,
    onClick = props.onClick,
    permissions = props.permissions,
    requiredPermission = props.requiredPermission,
    rightIcon = props.rightIcon,
    rightIconProps = props.rightIconProps,
    _props$style = props.style,
    style = _props$style === void 0 ? 'primary' : _props$style,
    tooltipAttributes = props.tooltipAttributes,
    variant = props.variant,
    additionalProps = _objectWithoutProperties(props, _excluded);
  var buttonClassName = _formatClassName([fontTheme || 'ui-default', className, _defineProperty(_defineProperty(_defineProperty({}, "btn-".concat(style, "-branded"), branded), 'btn-block', block), 'no-label', !label)]) || '';
  var dataProps = {};
  if (data.action) {
    dataProps['data-action'] = data.action;
  }
  if (data.objectId) {
    dataProps['data-object-id'] = data.objectId;
  }
  if (data.objectType) {
    dataProps['data-object-type'] = data.objectType;
  }
  if (data.componentType) {
    dataProps['data-component-type'] = data.componentType;
  }
  if (href) {
    dataProps['data-href'] = href;
  } else {
    dataProps['data-component-type'] = label ? "".concat(kebabCase(label), "-button") : 'button';
  }
  var spin = !!icon && icon === 'spinner';
  var dataAttributes = pickDataAttributes(props);
  var buttonVariant = style || variant;
  var onInternalClick = function onInternalClick(event) {
    if ((additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.target) === '_blank') {
      window.open(href, additionalProps === null || additionalProps === void 0 ? void 0 : additionalProps.target, 'noopener,noreferrer');
    } else if (href) {
      window.location.assign(href);
    }
    if (onClick) {
      onClick(event);
    }
  };
  var accessControlProps = _objectSpread2({
    permissions: permissions,
    requiredPermission: requiredPermission
  }, additionalProps);
  var downloadProps = {};
  if (download) {
    downloadProps.download = download;
    downloadProps.href = href;
    if (!href) {
      console.error("'href' is required when using 'download', considering adding it or removing 'download' if you use onClick to perform the download process.");
    }
  }
  var foundryButtonProps = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, additionalProps), dataProps), dataAttributes), downloadProps), {}, {
    className: buttonClassName,
    isDisabled: disabled,
    variant: buttonVariant,
    style: cssStyle,
    ref: forwardedRef
  });
  return /*#__PURE__*/React.createElement(AccessControlWrapper, accessControlProps, /*#__PURE__*/React.createElement(Button$1, _extends({}, foundryButtonProps, {
    disabled: props.disabled,
    onClick: onInternalClick
  }), icon && /*#__PURE__*/React.createElement(FAIcon, _extends({
    icon: icon,
    spin: spin,
    additionalClasses: "left"
  }, iconProps)), /*#__PURE__*/React.createElement("span", {
    className: "btn-text"
  }, label), rightIcon && /*#__PURE__*/React.createElement(FAIcon, _extends({
    icon: rightIcon,
    additionalClasses: "right"
  }, rightIconProps)), children), (tooltipAttributes === null || tooltipAttributes === void 0 ? void 0 : tooltipAttributes.tooltip) && /*#__PURE__*/React.createElement(InfoTooltip, _extends({
    tooltipPosition: "top"
  }, tooltipAttributes)));
});
Button.displayName = 'ButtonLegacy';
export { Button };